module.exports = __webpack_public_path__ + "static/media/dokua.4bb09716.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/dokua.png
// module id = 279
// module chunks = 0